import angular from 'angular';
import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import CifShare from './cif-share-modal.service';

export default angular
  .module('verifyApp.cif-share-modal', [uiRouter, uiBootstrap])
  .service('CifShareService', CifShare)
  .name;



// WEBPACK FOOTER //
// ./client/components/cif-share/index.js